import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { RegionClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.RegioneQuery],
  create: [SystemAuthorizations.RegioneAdd],
  edit: [SystemAuthorizations.RegioneUpdate],
  delete: [SystemAuthorizations.RegioneDelete],
});

export const headCells: HeadCell<RegionClient, keyof RegionClient>[] = [
  {
    id: 'code',
    label: 'Codice regione',
  },
  {
    id: 'name',
    label: 'Nome regione',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaRegionFilter = yup.object({
  code: yup.string(),
  name: yup.string(),
});
